import React, { useState } from 'react';
import { Container, Row, Col, Button, Form, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  FaCopy,
  FaWhatsapp,
  FaArrowRight,
  FaEnvelope,
  FaGlobe,
  FaCheckCircle
} from 'react-icons/fa';
import gharamaImage from '../images/eCards_pricing.png';
import '../styles/Gharama.css';

function Gharama() {
  // Calculator States
  const [guestsCount, setGuestsCount] = useState(200);
  const [cardTier, setCardTier] = useState(950);

  // Message 1: Ujumbe wa taarifa ya shughuli
  const [infoMsgCount, setInfoMsgCount] = useState(2);
  const [infoChannel, setInfoChannel] = useState('both');

  // Message 2: Ujumbe wa Kukumbushia michango ya ahadi
  const [remindMsgCount, setRemindMsgCount] = useState(5);
  const [remindChannel, setRemindChannel] = useState('both');

  const getSmsMultiplier = (channel) => {
    if (channel === 'sms' || channel === 'both') return 1;
    return 0;
  };
  const getWaMultiplier = (channel) => {
    if (channel === 'whatsapp' || channel === 'both') return 1;
    return 0;
  };

  const fallbackCopy = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      toast.success('Muhtasari wa makadirio umenakiliwa vizuri!');
    } catch (err) {
      toast.error('Imeshindwa kunakili muhtasari');
    }
    document.body.removeChild(textArea);
  };

  // Calculations
  const cardCost = guestsCount * cardTier;
  const totalSmsPerGuest = (infoMsgCount * getSmsMultiplier(infoChannel)) + (remindMsgCount * getSmsMultiplier(remindChannel));
  const smsCost = guestsCount * totalSmsPerGuest * 3 * 25;
  const totalWaPerGuest = (infoMsgCount * getWaMultiplier(infoChannel)) + (remindMsgCount * getWaMultiplier(remindChannel));
  const waCost = guestsCount * totalWaPerGuest * 75;
  const totalCost = cardCost + smsCost + waCost;

  // Free services list
  const freeServices = [
    "Tovuti ya shughuli",
    "Menejimenti ya bajeti",
    "Ahadi na michango",
    "Taarifa za fedha",
    "Ripoti za PDF/Excel",
    "Ripoti za WhatsApp",
    "Mialiko kwa Email"
  ];

  return (
    <div className="gharama-page">
      <Container className="py-4">
        <br /><br />

        {/* ===== HEADER ===== */}
        <div className="gharama-header text-center">

          <h1 className="gharama-title">
            Bei na Gharama
            <span className="title-gradient">Kadiria Matumizi Yako</span>
          </h1>
          <p className="gharama-subtitle">
            Kokotoa makadirio ya gharama ya kadi na ujumbe kulingana na idadi ya wageni wako
          </p>
        </div>

        {/* ===== ESTIMATOR CARD ===== */}
        <Row className="justify-content-center mb-5">
          <Col lg={11}>
            <Card className="gharama-estimator-card">
              <Card.Header className="estimator-header">
                <div className="header-left">
                  <div>
                    <h5 className="header-title">Kadiria Gharama Yako</h5>
                    <p className="header-subtitle">Jaza taarifa zako ili kupata makadirio</p>
                  </div>
                </div>
                <div className="header-actions">
                  <Button
                    variant="primary"
                    size="sm"
                    className="action-btn copy-btn"
                    onClick={() => {
                      const summaryText = `MAKADIRIO YA GHARAMA - HARUSI ONLINE\n---------------------------------\nIdadi ya Wageni: ${guestsCount}\nBei ya Kadi (e-Card): TZS ${cardTier} kwa kila mgeni (Jumla ya kadi zote: TZS ${cardCost.toLocaleString()})\n\nUjumbe wa Taarifa (x${infoMsgCount}):\n- Njia Inayotumika: ${infoChannel === 'sms' ? 'SMS Pekee' : infoChannel === 'whatsapp' ? 'WhatsApp Pekee' : 'SMS & WhatsApp'}\n\nUjumbe wa Kukumbushia (x${remindMsgCount}):\n- Njia Inayotumika: ${remindChannel === 'sms' ? 'SMS Pekee' : remindChannel === 'whatsapp' ? 'WhatsApp Pekee' : 'SMS & WhatsApp'}\n\nMchanganuo wa Gharama za Ujumbe:\n- SMS (Jumla ya credits ${guestsCount * totalSmsPerGuest * 3} kwa Sh. 25): TZS ${smsCost.toLocaleString()}\n- WhatsApp (Jumla ya Ujumbe ${guestsCount * totalWaPerGuest} kwa Sh. 75): TZS ${waCost.toLocaleString()}\n---------------------------------\nJUMLA KUU YA MAKADIRIO: TZS ${totalCost.toLocaleString()}\n\n Unaweza pia kufanya makadiria ya matumizi yako hapa: ${window.location.href}`;

                      if (navigator.clipboard && navigator.clipboard.writeText) {
                        navigator.clipboard.writeText(summaryText)
                          .then(() => toast.success('Muhtasari wa makadirio umenakiliwa vizuri!'))
                          .catch(() => fallbackCopy(summaryText));
                      } else {
                        fallbackCopy(summaryText);
                      }
                    }}
                  >
                    <FaCopy /> Copy Summary
                  </Button>
                  <Button
                    variant="success"
                    size="sm"
                    className="action-btn whatsapp-btn"
                    onClick={() => {
                      const summaryText = `MAKADIRIO YA GHARAMA - HARUSI ONLINE\n---------------------------------\nIdadi ya Wageni: ${guestsCount}\nBei ya Kadi (e-Card): TZS ${cardTier} kwa kila mgeni (Jumla ya kadi zote: TZS ${cardCost.toLocaleString()})\n\nUjumbe wa Taarifa (x${infoMsgCount}):\n- Njia Inayotumika: ${infoChannel === 'sms' ? 'SMS Pekee' : infoChannel === 'whatsapp' ? 'WhatsApp Pekee' : 'SMS & WhatsApp'}\n\nUjumbe wa Kukumbushia (x${remindMsgCount}):\n- Njia Inayotumika: ${remindChannel === 'sms' ? 'SMS Pekee' : remindChannel === 'whatsapp' ? 'WhatsApp Pekee' : 'SMS & WhatsApp'}\n\nMchanganuo wa Gharama za Ujumbe:\n- SMS (Jumla ya credits ${guestsCount * totalSmsPerGuest * 3} kwa Sh. 25): TZS ${smsCost.toLocaleString()}\n- WhatsApp (Jumla ya Ujumbe ${guestsCount * totalWaPerGuest} kwa Sh. 75): TZS ${waCost.toLocaleString()}\n---------------------------------\nJUMLA KUU YA MAKADIRIO: TZS ${totalCost.toLocaleString()}\n\nKadiria matumizi yako hapa: ${window.location.href}`;
                      const waUrl = `https://wa.me/?text=${encodeURIComponent(summaryText)}`;
                      window.open(waUrl, '_blank');
                    }}
                  >
                    <FaWhatsapp /> Share WhatsApp
                  </Button>
                </div>
              </Card.Header>

              <Card.Body className="estimator-body">
                <Row className="g-4">
                  {/* Inputs Column */}
                  <Col lg={6}>
                    <div className="estimator-inputs">
                      <h5 className="section-label">
                        <span className="step-number">1</span>
                        Ingiza Taarifa za Shughuli
                      </h5>

                      {/* Guests Count */}
                      <Form.Group className="input-group-modern">
                        <div className="input-header">
                          <Form.Label className="input-label">Idadi ya Wageni</Form.Label>
                          <Form.Control
                            type="number"
                            min={10}
                            max={5000}
                            value={guestsCount}
                            onChange={(e) => {
                              const val = parseInt(e.target.value);
                              setGuestsCount(isNaN(val) ? 0 : val);
                            }}
                            className="input-value"
                          />
                        </div>
                        <Form.Range
                          min={10}
                          max={1500}
                          step={10}
                          value={guestsCount > 1500 ? 1500 : guestsCount}
                          onChange={(e) => setGuestsCount(parseInt(e.target.value))}
                          className="custom-range"
                        />
                        <div className="range-labels">
                          <span>10 wageni</span>
                          <span>1,500 wageni</span>
                        </div>
                      </Form.Group>

                      {/* Card Price */}
                      <Form.Group className="input-group-modern">
                        <Form.Label className="input-label">
                          Bei ya Kadi (e-Card)
                        </Form.Label>
                        <div className="tier-options">
                          {[750, 950].map((tier) => (
                            <div
                              key={tier}
                              className={`tier-option ${cardTier === tier ? 'active' : ''}`}
                              onClick={() => setCardTier(tier)}
                            >
                              <span className="tier-price">TZS {tier}</span>
                            </div>
                          ))}
                        </div>
                      </Form.Group>

                      {/* Message 1 */}
                      <Form.Group className="input-group-modern">
                        <div className="input-header">
                          <Form.Label className="input-label">Ujumbe wa taarifa ya shughuli:</Form.Label>
                          <Form.Control
                            type="number"
                            min={0}
                            max={50}
                            value={infoMsgCount}
                            onChange={(e) => {
                              const val = parseInt(e.target.value);
                              setInfoMsgCount(isNaN(val) ? 0 : val);
                            }}
                            className="input-value"
                          />
                        </div>
                        <Form.Range
                          min={0}
                          max={20}
                          value={infoMsgCount > 20 ? 20 : infoMsgCount}
                          onChange={(e) => setInfoMsgCount(parseInt(e.target.value))}
                          className="custom-range"
                        />
                        <div className="channel-selector">
                          {[
                            { value: 'sms', label: 'SMS Pekee', icon: FaEnvelope },
                            { value: 'whatsapp', label: 'WhatsApp Pekee', icon: FaWhatsapp },
                            { value: 'both', label: 'SMS & WhatsApp', icon: null }
                          ].map((ch) => (
                            <button
                              key={ch.value}
                              className={`channel-btn ${infoChannel === ch.value ? 'active' : ''}`}
                              onClick={() => setInfoChannel(ch.value)}
                            >
                              {ch.icon && <ch.icon className="channel-icon" />}
                              <span>{ch.label}</span>
                            </button>
                          ))}
                        </div>
                        <div className="input-help">Makadirio ya jumbe za taarifa na shukurani kwa kila mgeni.</div>
                      </Form.Group>

                      {/* Message 2 */}
                      <Form.Group className="input-group-modern">
                        <div className="input-header">

                          <Form.Label className="input-label">Ujumbe wa Kukumbushia michango ya ahadi:</Form.Label>
                          <Form.Control
                            type="number"
                            min={0}
                            max={50}
                            value={remindMsgCount}
                            onChange={(e) => {
                              const val = parseInt(e.target.value);
                              setRemindMsgCount(isNaN(val) ? 0 : val);
                            }}
                            className="input-value"
                          />
                        </div>
                        <Form.Range
                          min={0}
                          max={20}
                          value={remindMsgCount > 20 ? 20 : remindMsgCount}
                          onChange={(e) => setRemindMsgCount(parseInt(e.target.value))}
                          className="custom-range"
                        />
                        <div className="channel-selector">
                          {[
                            { value: 'sms', label: 'SMS Pekee', icon: FaEnvelope },
                            { value: 'whatsapp', label: 'WhatsApp Pekee', icon: FaWhatsapp },
                            { value: 'both', label: 'SMS & WhatsApp', icon: null }
                          ].map((ch) => (
                            <button
                              key={ch.value}
                              className={`channel-btn ${remindChannel === ch.value ? 'active' : ''}`}
                              onClick={() => setRemindChannel(ch.value)}
                            >
                              {ch.icon && <ch.icon className="channel-icon" />}
                              <span>{ch.label}</span>
                            </button>
                          ))}
                        </div>
                        <div className="input-help">Makadirio ya jumbe za kukumbushia michango kwa kila mgeni.</div>
                      </Form.Group>
                    </div>
                  </Col>

                  {/* Results Column */}
                  <Col lg={6}>
                    <div className="estimator-results">
                      <h5 className="section-label">
                        <span className="step-number">2</span>
                        Mchanganuo wa Makadirio
                      </h5>

                      <div className="result-item">
                        <div className="result-info">
                          <div>
                            <span className="result-label">Gharama ya Kadi</span>
                            <small>{guestsCount} Wageni × TZS {cardTier}</small>
                          </div>
                        </div>
                        <span className="result-value">TZS {cardCost.toLocaleString()}</span>
                      </div>

                      <div className="result-item">
                        <div className="result-info">
                          <FaEnvelope className="result-icon" style={{ color: '#4f46e5' }} />
                          <div>
                            <span className="result-label">Gharama ya SMS</span>
                            <small>{guestsCount * totalSmsPerGuest * 3} Credits × TZS 25</small>
                            <small className="result-note">*Imekadiriwa kila ujumbe utagharimu SMS credits 3</small>
                          </div>
                        </div>
                        <span className="result-value">TZS {smsCost.toLocaleString()}</span>
                      </div>

                      <div className="result-item">
                        <div className="result-info">
                          <FaWhatsapp className="result-icon" style={{ color: '#25d366' }} />
                          <div>
                            <span className="result-label">Gharama ya WhatsApp</span>
                            <small>{guestsCount * totalWaPerGuest} Ujumbe × TZS 75</small>
                          </div>
                        </div>
                        <span className="result-value">TZS {waCost.toLocaleString()}</span>
                      </div>

                      <div className="result-total">
                        <div className="total-info">
                          <span className="total-label">Jumla Kuu</span>
                          <small className="total-note">Makadirio ya jumla ya gharama zote</small>
                        </div>
                        <span className="total-value">TZS {totalCost.toLocaleString()}</span>
                      </div>

                      <div className="result-footer">
                        <p className="result-note-text">
                          Makadirio haya hayatohusisha Uhakiki wa kadi mlangoni (scanning)
                        </p>
                        <p className="result-note-text">
                          Malipo yatafanyika kwa awamu, wakati wa matumizi ya huduma husika (Pay-As-You-Go)
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* ===== INFO SECTION ===== */}
        <Row className="gharama-info-section align-items-center">
          <Col md={6}>
            <div className="info-image-wrapper">
              <img src={gharamaImage} alt="Gharama" className="info-image" />
            </div>
          </Col>
          <Col md={6} className="info-content">

            <h2 className="info-title">
              Pay-As-You-Go
              <span className="info-title-highlight">Malipo Kadri Unavyotumia</span>
            </h2>
            <p className="info-description">
              Harusi Online inatumia mfumo wa kulipia kadri unavyotumia, yaani 'Pay-As-You-Go'
              katika utaratibu wa kujihudumia mwenyewe (Self-Service).
            </p>

            <div className="free-services">
              <h4 className="free-services-title">Huduma Hizi ni <span className="free-highlight">BURE</span>:</h4>
              <div className="free-services-grid">
                {freeServices.map((service, index) => (
                  <div key={index} className="free-service-item">
                    <FaCheckCircle className="free-check" />
                    <span>{service}</span>
                  </div>
                ))}
              </div>
            </div>

            <p className="info-description mt-3">
              Kwa mtoa huduma, hakuna gharama utakayochajiwa kwa kuweka taarifa kwenye profile yako
              na kwa platform ya HarusiOnline kukutanisha na wateja.
            </p>

            <div className="info-cta">
              <Link to="/login">
                <Button className="info-cta-btn">
                  Jisajili Sasa
                  <FaArrowRight className="ms-2" />
                </Button>
              </Link>
              <span className="info-cta-note">Hakuna malipo ya kujiunga</span>
            </div>
          </Col>
        </Row>



      </Container>
    </div>
  );
}

export default Gharama;